import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Environment } from '../../../environment';
import { GetBarnsResponse, Barn, UpsertBarnResponse } from '../models/barn-service.model';

@Injectable({
  providedIn: 'root',
})
export class BarnService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/barn/secure/barn`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  upsertBarn(barn: Barn): Observable<UpsertBarnResponse> {
    return this.http.post<UpsertBarnResponse>(this.baseUrl, barn, {});
  }

  deleteBarn(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  getBarns(): Observable<Barn[] | HttpErrorResponse> {
    return this.http.get<GetBarnsResponse>(this.baseUrl).pipe(
      map((response: GetBarnsResponse) => response.barns),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Barn[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }
}
